<template>
  <div>
    <div class="collection-form" v-show="outerVisible">
      <div class="header">
        <div class="back" @click="goback">返回</div>
        <div class="title-label">{{ paramCollection.title }}</div>
      </div>
      <!-- form-information start -->
      <div class="form-information">
        <!-- // todo上游收款 -->
        <template v-if="paramCollection.streamType === '1'">
          <!-- // !收票方（支付方） -->
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>付款方</div>
              <el-select
                size="small"
                :disabled="form.operationType === '关联新增方式' || isDisabled"
                @change="payTenantNameChange"
                v-model="form.payTenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <el-option
                  v-for="item in receiveTenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- // !开票方（收款方） -->
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>收款方</div>
              <el-input
                @focus="showCollectionBankList(form.receiveTenantGuid)"
                :disabled="isDisabled"
                size="small"
                readonly
                @input="receiveTenantNameInput"
                v-model="form.receiveTenantName"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <i
                  class="el-icon-arrow-down el-input__icon"
                  slot="suffix"
                  @click="showCollectionBankList(form.receiveTenantGuid)"
                >
                </i>
              </el-input>
            </div>
          </div>
          <!-- 收款银行信息 -->
          <div class="cols" v-show="selectBankObj.bankAccount">
            <div class="col-itms">
              <div class="title-label"></div>
              <div class="bank-content-info w300">
                <div><span class="bank-info">账户类型：</span>{{ selectBankObj.accountType | accountTypeFilter }}</div>
                <div><span class="bank-info">开户银行：</span>{{ selectBankObj.bankName }}</div>
                <div><span class="bank-info">银行账号：</span>{{ selectBankObj.bankAccount }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- // todo下游付款 -->
        <template v-if="paramCollection.streamType === '2'">
          <!-- // !收票方（支付方） -->
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>付款方</div>
              <el-select
                size="small"
                :disabled="form.operationType === '关联新增方式' || isDisabled"
                @change="payTenantNameChange"
                v-model="form.payTenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <el-option
                  v-for="item in form.operationType === '关联新增方式' ? receiveTenantList : invoiceTenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </div>
            <!-- // !开票方（收款方） -->
            <div class="col-itms second">
              <div class="title-label"><span>*</span>收款方</div>
              <el-select
                size="small"
                :disabled="form.operationType === '关联新增方式' || isDisabled"
                @change="receiveTenantNameChange"
                v-model="form.receiveTenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <el-option
                  v-for="item in form.operationType === '关联新增方式' ? invoiceTenantList : receiveTenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cols" v-if="['2'].includes(paramCollection.streamType)">
          <div class="col-itms">
            <div class="title-label"><span>*</span>付款银行</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.payBankAccount"
              placeholder="请选择"
              filterable
              class="w300"
              @change="payBankNameChange"
            >
              <el-option
                v-for="(item,index) in payBankList"
                :key="index"
                :label="item.bankName"
                :value="item.bankAccount"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-itms second">
            <div class="title-label"><span>*</span>付款银行账户</div>
              {{ form?.payBankAccount || '-' }}
          </div>
        </div>
          <!-- //?收款银行信息 -->
          <!-- <div class="cols" v-show="checkBankObj.bankAccount">
            <div class="col-itms">
              <div class="title-label"></div>
              <div class="bank-content w300">
                <div><span class="bank-info">账户类型：</span>{{checkBankObj.accountType}}</div>
                <div><span class="bank-info">开户银行：</span>{{checkBankObj.bankName}}</div>
                <div><span class="bank-info">银行账号：</span>{{checkBankObj.bankAccount}}</div>
              </div>
            </div>
          </div> -->
        </template>

         <!-- // todo下游退款 -->
        <template v-if="paramCollection.streamType === '3'">
          <!-- // !代征公司 -->
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>支付方</div>
              <el-select
                size="small"
                :disabled="form.operationType === '关联新增方式' || isDisabled"
                @change="payTenantNameChange"
                v-model="form.payTenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <el-option
                  v-for="item in  receiveTenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </div>
            <!-- // !服务商 -->
            <div class="col-itms second">
              <div class="title-label"><span>*</span>收款方</div>
              <el-select
                size="small"
                :disabled="form.operationType === '关联新增方式' || isDisabled"
                @change="receiveTenantNameChange"
                v-model="form.receiveTenantGuid"
                placeholder="请选择"
                filterable
                class="w300"
              >
                <el-option
                  v-for="item in invoiceTenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </template>

        <div class="cols">
          <div class="col-itms">
            <div class="title-label"><span>*</span>{{ receiveDateLabel[paramCollection.streamType] }}</div>
            <el-date-picker
              :disabled="isDisabled"
              class="w300"
              size="small"
              type="date"
              placeholder="请选择"
              v-model="form.receiveDate"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="col-itms second">
            <div class="title-label">
              <span v-if="['2','3'].includes(paramCollection.streamType)">*</span>
              对应款项
            </div>
            <el-select
              :clearable="!['2','3'].includes(paramCollection.streamType)"
              size="small"
              :disabled="form.operationType === '关联新增方式' || isDisabled"
              v-model="form.correspondItem"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('对应款项')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title-label">
              <span>*</span>{{ receiveAmountLabel[paramCollection.streamType] }}
            </div>
            <el-input
              :disabled="isDisabled"
              size="small"
              class="w300"
              ref="receiveAmountRef"
              :maxlength="18"
              @change="blurReceiveAmount"
              v-model="form.receiveAmount"
              placeholder="请填写"
            ></el-input>
          </div>
          <div class="col-itms second" v-show="paramCollection.streamType === '2'">
            <div class="title-label"><span>*</span>药企名称</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.operationReportTenantGuid"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in sendTenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 合同名称:仅下游收款列表传showContract且查看/编辑态时展示(新增态operationMode为空不渲染),其它共用页不渲染 -->
        <div class="cols" v-if="showContract && operationMode">
          <div class="col-itms">
            <div class="title-label">合同名称</div>
            <div>{{ form.contractName || '-' }}</div>
          </div>
        </div>
        <div class="cols" v-if="form.receiveAmount">
          <div class="col-itms">
            <div class="title-label">大写金额</div>
            <div>{{ form.receiveAmount | upDigit }}</div>
          </div>
        </div>
    
        <div v-if="['2'].includes(paramCollection.streamType)">
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>收款银行</div>
              <el-select
                size="small"
                :disabled="isDisabled"
                v-model="form.bankAccount"
                placeholder="请选择"
                filterable
                class="w300"
                @change="receiveBankAccountChange"
              >
                <el-option
                  v-for="(item, index) in bankList"
                  :key="index"
                  :label="item.bankName"
                  :value="item.bankAccount"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-itms second">
              <div class="title-label"><span>*</span>收款银行账户</div>
              {{ form?.bankAccount || "-" }}
            </div>
          </div>
          <div class="cols">
            <div class="col-itms">
              <div class="title-label"><span>*</span>退款状态:</div>
              <el-select
                size="small"
                :disabled="true"
                v-model="form.refundType"
                filterable
                placeholder=""
                class="w300"
              >
                <el-option
                  v-for="item in refundTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-itms second">
              <div class="title-label">流程编号</div>
              <el-input
                :disabled="isDisabled"
                size="small"
                class="w300"
                @input="handleApproveFlowNoInput"
                :value="form.approveFlowNo"
                placeholder="请填写"
              ></el-input>
            </div>
          </div>
        </div>
       
        <div class="cols">
          <div class="col-itms">
            <div class="title-label"><span>*</span>是否垫资款</div>
            <el-radio-group :disabled="isDisabled" v-model="form.isCapitalAdvances">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <!-- form-information end -->

      <div class="operte-btns">
        <div class="btn cancel" @click="goback">取消</div>
        <div class="btn submit" @click="submitCollection" v-if="!isDisabled">确定</div>
      </div>
    </div>
    <!-- 银行账户列表 start -->
    <div class="bank-list">
      <el-dialog width="910px" :title="selectTitle" :visible.sync="innerVisible" left>
        <div slot="title" class="dialog-title">
          {{ selectTitle }}
        </div>
        <div class="bank-content">
          <div class="bank-search">
            <el-row>
              <div style="display: inline-block; padding-right: 10px">
                <el-select
                  size="mini"
                  class="w300"
                  filterable
                  :disabled="form.operationType === '关联新增方式'"
                  v-model="form.receiveTenantGuid"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in invoiceTenantList"
                    :label="item.tenantName"
                    :value="item.guid"
                    :key="item.guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-button size="mini" type="info" @click="searchBank">搜索</el-button>
              <el-button size="mini" @click="emptySearch">清空</el-button>
            </el-row>
          </div>
          <div class="back-color-fff bank-list-table">
            <el-table
              ref="table"
              :data="bankTableData"
              stripe
              border
              style="width: 100%"
              max-height="400"
              v-loading="tableLoading"
              @row-click="rowClickHandle"
              highlight-current-row
            >
              <el-table-column align="center" width="80" label="选择">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="selectCode" :label="scope.row.guid">
                    <span></span>
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="receiveTenantName"
                label="收款方"
                show-overflow-tooltip
                header-align="left"
                align="left"
                width="210"
              >
                <template slot-scope="scope">{{ scope.row.receiveTenantName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="accountType"
                label="账户类型"
                show-overflow-tooltip
                header-align="left"
                align="left"
                width="100"
              >
                <template slot-scope="scope">{{ scope.row.accountType | accountTypeFilter }}</template>
              </el-table-column>
              <el-table-column
                prop="bankName"
                label="开户银行"
                show-overflow-tooltip
                header-align="left"
                align="left"
                width="180"
              >
                <template slot-scope="scope">{{ scope.row.bankName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="bankAccount"
                label="银行账户"
                show-overflow-tooltip
                header-align="left"
                align="left"
              >
                <template slot-scope="scope">{{ scope.row.bankAccount || '-' }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operte-btns">
          <div class="btn cancel" @click="innerVisible = false">取消</div>
          <div class="btn submit" @click="submitBank">确定</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getTenantDetail } from '@/api/msCustomerService';
export default {
  props: ['paramCollection', 'receiveTenantList', 'invoiceTenantList', 'allList','sendTenantList','tenantDetail','showContract'],
  data() {
    return {
      refundTypeList: [
        {
          label: '全额退款',
          value: '1',
        },
        {
          label: '部分退款',
          value: '2',
        },
      ],
      receiveAmountLabel:{
        '1':'收款金额(元)',
        '2':'付款金额(元)',
        '3':'退款金额(元)',
      },
      receiveDateLabel:{
        '1':'收款日期',
        '2':'付款日期',
        '3':'退款日期',
      },
      checkList:{
        '1':'checkPayForm',
        '2':'checkReceiveForm',
        '3':'checkRefundForm',
      },
      selectTitle: '选择银行', // 选择银行的弹框
      guid: '',
      operationMode: '', // 页面操作方式
      outerVisible: false,
      innerVisible: false,
      tableLoading: false,
      selectCode: '',
      selectBankObj: {},
      checkBankObj: {},
      bankTableData: [],
      form: {
        correspondItem: '',
        receiveDate: '', // 收款时间
        payTenantGuid: '', // !收票方（支付方）唯一标识
        payTenantName: '', // !收票方（支付方）名称
        receiveTenantGuid: '', // !开票方（收款方）唯一标识
        receiveTenantName: '', // !开票方（收款方）名称
        receiveAmount: undefined, // 收款金额
        isCapitalAdvances: '', // 是否垫资
        operationReportTenantGuid:'',//下游付款的药企名称
        operationReportTenantName:'',//下游付款的药企名称
        contractName: '',// 销售合同名称(详情展示,由后端detail接口返回)
        taskType: '',// 任务大类
        refundType: '',// 退款状态
        approveFlowNo: '',// 流程编号
        payBankName: '', // 付款银行
        payBankAccount: '',// 付款银行账户
        bankName: '', // 收款银行
        bankAccount: '',// 收款银行账户
      },
      payBankList: [],
      bankList: [],
      
    };
  },
  created() {
    // 触发编辑的监听事件
    this.$root.$on('collection-editAndLookData', (param) => {
      let { data, type } = param;
      this.operationMode = type;

      this.rendeEditModel(data);
      this.blurReceiveAmount();
    });
  },
  watch: {
    innerVisible: {
      // 监听银行信息表单打开
      handler(val) {
        if (val) {
          this.bankTableData = [];
          this.selectCode = ''
        }
      },
    },
    outerVisible: {
      // 监听新增收款信息表单打开
      handler(val) {
        if (val) {
          if (this.paramCollection.operationType !== '关联新增方式') {
            this.resetForm();
          } else {
            this.form.receiveAmount = undefined;
            this.form.isCapitalAdvances = '';
            this.form.receiveDate = '';
          }
        }
      },
    },
    paramCollection: {
      deep: true,
      handler(val) {
        if (Object.keys(val).length) {
          this.form.operationType = val.operationType;
          this.form.payTenantGuid = val.receiveTenantGuid; // 收票方（支付方）唯一标识
          this.form.payTenantName = val.receiveTenantName;
          this.form.receiveTenantGuid = val.invoiceTenantGuid; // 开票方（收款方）唯一标识
          this.form.receiveTenantName = val.invoiceTenantName;
          // this.form.correspondItem = val.correspondItem;
          this.form.correspondItem = val.counterpartGuid;//对应款项
          this.form.operationReportTenantGuid = val.operationReportTenantGuid||'';//下游付款的药企名称
          this.form.operationReportTenantName = val.operationReportTenantName||'';//下游付款的药企名称
        }
      },
    },
    'form.operationReportTenantGuid': {
      handler(newVal, oldVal) {
        let self = this;
        self.sendTenantList.forEach(function (item) {
          if (self.form.operationReportTenantGuid == item.sendTenantGuid) {
            self.form.operationReportTenantName = item.sendTenantName;
          }
        });
      },
      deep: true, // 是否深度监听
    },
  },
  computed: {
    isDisabled() {
      return this.operationMode === 'look';
    },
  },
  methods: {
    handleApproveFlowNoInput(value) {
      // 只保留数字 最多20个字符
      const maxLength = 20;
      if (value.length > maxLength) {
        this.$message.error(`流程编号最多${maxLength}个字符`);
        return;
      }
      this.form = {
        ...this.form,
        approveFlowNo: value.replace(/[^\d]/g, '').substring(0, maxLength)
      }
    },
    payBankNameChange(value) {
      const payBank = this.payBankList.find((item) => item.bankAccount === value);
       this.form = {
        ...this.form,
        payBankAccount: value,
        payBankName: payBank?.bankName || '',
      }
    },
    // 获取银行列表
    getBankList(guid) {
      let self = this;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${guid}`).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.bankTableData = res.data.data.bankList;
          self.bankTableData.forEach((item) => {
            item.receiveTenantName = res.data.data.tenantName;
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    
    // 选择对应的收款方和银行信息
    rowClickHandle(row) {
      if (this.form.operationType === '关联新增方式') {
        this.selectCode = row.guid;
        let bankItem = this.bankTableData.find((item) => item.guid === row.guid);
        this.checkBankObj = bankItem;
      } else {
        // 列表入口新增的逻辑
        this.selectCode = row.guid;
        let bankItem = this.bankTableData.find((item) => item.guid === row.guid);
        this.checkBankObj = bankItem;
        // this.checkBankObj = bankItem;
        // let invoiceTenantItem = this.invoiceTenantList.find((item) => item.guid === this.form.receiveTenantGuid);
        // this.form.receiveTenantGuid = invoiceTenantItem.guid;
        // this.form.receiveTenantName = invoiceTenantItem.tenantName;
      }
    },
    // 支付方change
    payTenantNameChange(val) {
      if (this.paramCollection.streamType === '1') {
        const filterItem = this.receiveTenantList.filter((item) => item.guid == val);
        this.form.payTenantName = filterItem[0].tenantName;
      } else if (this.paramCollection.streamType === '2') {
        let arr = this.form.operationType === '关联新增方式' ? this.receiveTenantList : this.invoiceTenantList;
        const filterItem = arr.filter((item) => item.guid == val);
        this.form.payTenantName = filterItem[0].tenantName;
        this.getPayBankList(val);
        this.form.payBankName = '';
        this.form.payBankAccount = '';
      } else if (this.paramCollection.streamType === '3') {
        let arr = this.receiveTenantList;
        const filterItem = arr.filter((item) => item.guid == val);
        this.form.payTenantName = filterItem[0].tenantName;
      }
    },
    //收款方input
    receiveTenantNameInput(val) {
      let { form } = this;
      let { paramCollection } = this;
      if (paramCollection.title === '新增上游收款信息') {
        form.receiveTenantName = paramCollection.invoiceTenantName;
      }
    },
    async getPayBankList(guid) {
      const { data } = await getTenantDetail(guid);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.payBankList = data.data.bankList;
    },
    async getTenantDetailData(guid) {
      const { data } = await getTenantDetail(guid);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.bankList = data.data.bankList;
    },
    receiveBankAccountChange(value) {
      const bank = this.bankList.find((item) => item.bankAccount === value);
      this.form = {
        ...this.form,
        bankAccount: value,
        bankName: bank?.bankName || '',
      }
    },
    receiveTenantNameChange(val) {
      if (this.paramCollection.streamType === '2') {
        const filterItem = this.receiveTenantList.filter((item) => item.guid == val);
        this.form.receiveTenantName = filterItem[0].tenantName;
        this.form.bankName = '';
        this.form.bankAccount = '';
        this.getTenantDetailData(val);
      }
      if (this.paramCollection.streamType === '3') {
        const filterItem = this.invoiceTenantList.find((item) => item.guid == val);
        this.form.receiveTenantName = filterItem.tenantName || '';
      }
    },
    // 关闭
    goback() {
      this.outerVisible = false;
      this.operationMode = ''; // !重置操作状态
      this.$emit('closedDialogBox', 'closed');
    },
    // 提交收款信息
    submitCollection() {
      let fnName = this.checkList[this.paramCollection.streamType]
      if (!this[fnName]()) return;
      let { form } = this;
      let { paramCollection } = this;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let param = {
        streamType: this.paramCollection.streamType, // 判断上下游 1上游 2下游
        payTenantGuid: form.payTenantGuid,
        payTenantName: form.payTenantName,
        receiveTenantGuid: form.receiveTenantGuid,
        receiveTenantName: form.receiveTenantName,
        receiveDate: form.receiveDate,
        correspondItem: form.correspondItem, // 对应款项
        receiveAmount: form.receiveAmount,
        isCapitalAdvances: form.isCapitalAdvances,
        taskType: form.taskType,
        refundType: form.refundType,
        approveFlowNo: form.approveFlowNo,
        payBankName: form.payBankName,
        payBankAccount: form.payBankAccount,
        operationReportTenantGuid: form.operationReportTenantGuid,
        operationReportTenantName: form.operationReportTenantName,
        bankName: this.selectBankObj.bankName,
        bankAccount: this.selectBankObj.bankAccount,
        accountType: this.selectBankObj.accountType,
        createUserName: userInfo.staffName,
      };
      if (this.paramCollection.streamType === '2') {
        param.bankName = form.bankName;
        param.bankAccount = form.bankAccount;
      }

      let self = this;
      if (this.guid) {
        param.guid = this.guid;
        self.api.put(`/${serverConfig.msCustomerService}/invoiceItem/update`, param).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '修改成功',
              type: 'success',
            });
            this.goback();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        param.guid = null;
        self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/add`, param).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            param.guid = res.data.data;
            this.$message({
              message: '新增成功',
              type: 'success',
            });
            this.goback();
            this.$emit('getCollectionInfo', param);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    // 获取收款方银行账户列表
    showCollectionBankList(guid) {
      this.innerVisible = true;
      if (guid) this.getBankList(guid);
    },
    // 查询银行列表
    searchBank() {
      this.getBankList(this.form.receiveTenantGuid);
    },
    emptySearch() {
      this.form.receiveTenantGuid = '';
    },
    submitBank() {
      if (this.form.operationType === '关联新增方式') {
        this.selectBankObj = this.checkBankObj;
      } else {
        // !列表新增方式
        this.selectBankObj = this.checkBankObj;
        this.form.receiveTenantGuid = this.selectBankObj.tenantGuid;
        this.form.receiveTenantName = this.selectBankObj.receiveTenantName;
      }
      this.innerVisible = false;
    },
    // 校验付款表单方法
    checkPayForm() {
      if (!this.form.payTenantGuid) {
        this.$message.error('支付方不能为空');
        return false;
      }
      if (!this.form.receiveTenantName) {
        this.$message.error('收款方不能为空');
        return false;
      }
      if (!this.selectBankObj.bankAccount) {
        this.$message.error('收款方银行不能为空');
        return false;
      }
      if (!this.form.receiveDate) {
        this.$message.error('收款时间不能为空');
        return false;
      }
      if (!this.form.receiveAmount) {
        this.$message.error('请输入正确金额');
        return false;
      }
      // 上游收款时 对应款项可为空
      // if (!this.form.correspondItem) {
      //   this.$message.error('对应款项不能为空');
      //   return false;
      // }
      if (!this.form.isCapitalAdvances) {
        this.$message.error('是否垫资不能为空');
        return false;
      }
      return true;
    },
    // 校验付款表单方法
    checkReceiveForm() {
      if (!this.form.payTenantGuid) {
        this.$message.error('付款方不能为空');
        return false;
      }
      if (!this.form.receiveTenantName) {
        this.$message.error('收款方不能为空');
        return false;
      }
      if (!this.form.payBankName) {
        this.$message.error('付款银行不能为空');
        return false;
      }
      if (!this.form.payBankAccount) {
        this.$message.error('付款银行账户不能为空');
        return false;
      }
      if (!this.form.bankName) {
        this.$message.error('收款银行不能为空');
        return false;
      }
      if (!this.form.bankAccount) {
        this.$message.error('收款银行账户不能为空');
        return false;
      }
      if (!this.form.receiveDate) {
        this.$message.error('付款日期不能为空');
        return false;
      }
      if (!this.form.correspondItem) {
        this.$message.error('对应款项不能为空');
        return false;
      }
      if (!this.form.receiveAmount) {
        this.$message.error('请输入正确金额');
        return false;
      }
      // if (!this.form.taskType) {
      //   this.$message.error('请选择任务大类');
      //   return false;
      // }
      if (!this.form.operationReportTenantGuid) {
        this.$message.error('药企名称不能为空');
        return false;
      }
      if (!this.form.isCapitalAdvances) {
        this.$message.error('是否垫资不能为空');
        return false;
      }
      return true;
    },
    // 校验退款表单方法
    checkRefundForm() {
      if (!this.form.payTenantGuid) {
        this.$message.error('支付方不能为空');
        return false;
      }
      if (!this.form.receiveTenantName) {
        this.$message.error('收款方不能为空');
        return false;
      }
      if (!this.form.receiveDate) {
        this.$message.error('退款日期不能为空');
        return false;
      }
      if (!this.form.receiveAmount) {
        this.$message.error('请输入正确金额');
        return false;
      }
      if (!this.form.correspondItem) {
        this.$message.error('对应款项不能为空');
        return false;
      }
      if (!this.form.isCapitalAdvances) {
        this.$message.error('是否垫资不能为空');
        return false;
      }
      return true;
    },
    resetForm() {
      this.guid = '';
      this.form = {
        operationType: '',
        correspondItem: '',
        receiveDate: '', // 收款时间
        payTenantGuid: '', // !收票方（支付方）唯一标识
        payTenantName: '', // !收票方（支付方）名称
        receiveTenantGuid: '', // !开票方（收款方）唯一标识
        receiveTenantName: '', // !开票方（收款方）名称
        receiveAmount: undefined, // 收款金额
        isCapitalAdvances: '', // 是否垫资
        operationReportTenantGuid:'',//下游付款的药企名称
        operationReportTenantName:'',//下游付款的药企名称
        taskType: undefined,
        bankName: undefined,
        bankAccount: undefined,
      };
      this.checkBankObj = {};
      this.selectBankObj = {};
    },
    // 渲染编辑模式数据
    rendeEditModel(data) {
      let { form } = this;
      let { selectBankObj } = this;
      this.guid = data.guid;
      form = Object.assign(form, data);
      form.correspondItem = form.correspondItem;
      selectBankObj.bankName = data.bankName;
      selectBankObj.bankAccount = data.bankAccount;
      selectBankObj.accountType = data.accountType;
      if (this.paramCollection.streamType === '2' && form.receiveTenantGuid) {
        this.getTenantDetailData(form.receiveTenantGuid);
      }
      if(this.paramCollection.streamType === '2' && form.payTenantGuid){
        this.getPayBankList(form.payTenantGuid);
      }
    },
    blurReceiveAmount() {
      let { form } = this;
      let num = form.receiveAmount;
      num += '';
      num = num.replace(/[^0-9|\.]/g, ''); //清除字符串中的非数字非.字符
      if (/[^\d.]/.test(num)) {
        this.$message.error('请输入正确的金额');
      } else {
        if (this.operationMode === 'look') {
          if (/^0+/)
            //清除字符串开头的0
            num = num.replace(/^0+/, '');
          if (!/\./.test(num))
            //为整数字符串在末尾添加.00
            num += '.0000';
          if (/^\./.test(num))
            //字符以.开头时,在开头添加0
            num = '0' + num;
          num += '0000'; //在字符串末尾补零
          num = num.match(/\d+\.\d{4}/)[0];
        } else {
          if (/^0+/)
            //清除字符串开头的0
            num = num.replace(/^0+/, '');
          if (!/\./.test(num))
            //为整数字符串在末尾添加.00
            num += '.00';
          if (/^\./.test(num))
            //字符以.开头时,在开头添加0
            num = '0' + num;
          num += '00'; //在字符串末尾补零
          num = num.match(/\d+\.\d{2}/)[0];
        }
        form.receiveAmount = num;
      }
    },
  },
};
</script>

<style scoped>
/* 数字输入框样式 */
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
/* 银行表格央视 */
/deep/.bank-list-table .el-table {
  font-size: 12px;
  color: #212121;
}
/deep/.bank-list-table .el-table__body-wrapper tr,
.bank-list-table .el-table__body td.el-table__cell {
  height: 40px;
}
/deep/.bank-list-table .el-table__body-wrapper tr td {
  /* border-right: 1px solid #D9D9D9; */
}
/deep/.bank-list-table .el-table .el-table__cell {
  padding: 0px;
}
/deep/.bank-list-table .el-table th.el-table__cell {
  background-color: #f2f2f2;
  height: 32px;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
}
/deep/.bank-list-table .el-table th.el-table__cell:last-child {
  border-right: none;
}
/deep/.bank-list-table .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}
/* /deep/.bank-list-table .el-table td.el-table__cell, .bank-list-table .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #D9D9D9;
} */
/deep/.bank-list .el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/deep/.bank-list.el-dialog__body {
  padding: 10px 10px;
}
.dialog-title {
  width: 120px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.bank-search {
  padding-bottom: 10px;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
}
.bank-content-info {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 5px 10px;
}
.bank-info {
  color: #a7a7a7;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.header .title-label {
  text-align: center;
  flex: 1;
}
.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}
.operte-btns {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 15px 0;
  border-top: 1px solid #d9d9d9;
}
.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}
.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.form-information .cols {
  background: #fff;
  display: flex;
  padding: 8px 16px;
  padding-left: 20px;
}
.form-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.form-information .col-itms .title-label {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}
.form-information .col-itms .title-label span {
  color: red !important;
}
.form-information .col-itms.second {
  margin-left: 80px;
}
</style>
